import {
  ChecklistTrackedItemDto,
  ChecklistUntrackedItemDto,
} from '@peritasai/types';

/**
 * Checklist  Item Entity
 * Wraps ChecklistItemDto
 */
export class ChecklistItemEntity {
  public readonly checklistItemId: string;
  public readonly catalogItemId: string;
  public readonly allocated: boolean;
  public readonly assetId: string | null;
  public readonly notes: string | null;
  public readonly reassigned: boolean;
  public readonly released: boolean;

  constructor(dto: ChecklistUntrackedItemDto | ChecklistTrackedItemDto) {
    this.checklistItemId = dto.checklistItemId;
    this.catalogItemId = dto.catalogItemId;
    this.allocated = dto.allocated;
    this.assetId = dto.assetId || null;
    this.notes = dto.notes || null;
    this.reassigned = 'reassigned' in dto ? dto.reassigned : false;
    this.released = 'released' in dto ? dto.released : false;
  }

  public get isAllocated(): boolean {
    return this.allocated;
  }

  public get isActivelyAssigned(): boolean {
    return !!this.assetId && !this.reassigned && !this.released;
  }
}
